import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0219 from "../../../lesson/course-02/lesson-19/lesson";
import lesson0220 from "../../../lesson/course-02/lesson-20/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2a46155d-b4d1-4023-b361-2c1003969bb9",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0219),
    lesson: lesson0219,
  },
  {
    id: "3a0c53d6-dfa1-4043-9b44-600000f744b6",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0220),
    lesson: lesson0220,
  },
];

export default lessonLinks;
